import { array, coerce, object, optional, string } from 'superstruct';
import { EditPermissionsDto } from '@arc/shared/util-data';
import { ViewRoleDto } from '@arc/shared/util-roles';
import { email, matchesField, parsableBoolean, password, phoneNumber, userString } from '@arc/shared/util-superstruct';
export const EditUserFormDto = object({
  name: userString('validations:Required'),
  phone: optional(phoneNumber()),
  email: email(),
  password: optional(coerce(password(), string(), value => value === '' ? undefined : value)),
  superuser: optional(parsableBoolean()),
  permissions: EditPermissionsDto,
  roles: optional(array(ViewRoleDto)),
  verifiedPassword: matchesField('password', 'validations:VerifiedPassword')
});